export default __webpack_public_path__ + "static/media/howToCreateCashRegister.3588177e.png";